import { render, staticRenderFns } from "./ReleaseGPsManager.vue?vue&type=template&id=690667b0&"
import script from "./ReleaseGPsManager.vue?vue&type=script&lang=ts&"
export * from "./ReleaseGPsManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports